import React, { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import axios from "axios";
import Swal from "sweetalert2";

const BlanqueadorContraseaUsuariosQR = ({ onClose }) => {
  const scannerRef = useRef(null);
  const procesando = useRef(false);

  const detenerScanner = async () => {
    try {
      if (scannerRef.current) {
        const state = scannerRef.current.getState?.();

        if (state === 2) {
          await scannerRef.current.stop();
        }

        scannerRef.current.clear();
        scannerRef.current = null;
      }
    } catch (err) {
      console.warn("Error cerrando scanner", err);
    }
  };

  const enviar = async (dni) => {
    try {
      const username = process.env.REACT_APP_KEY;
      const password = process.env.REACT_APP_PASS;
      const token = btoa(`${username}:${password}`);

      await axios.post(
        process.env.REACT_APP_BASEURL +
          `calificaciones/actualizaUsuarioCalificaciones/${dni}`,
        {
          blanqueoContrasena: 0,
        },
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: `✔ DNI ${dni}`,
        showConfirmButton: false,
        timer: 1000,
      });

    } catch (error) {
      console.error(error);

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Ya blanqueado",
        showConfirmButton: false,
        timer: 1000,
      });
    } finally {
      procesando.current = false;
    }
  };

  useEffect(() => {
    const scanner = new Html5Qrcode("qr-reader");
    scannerRef.current = scanner;

    const iniciar = async () => {
      try {
        await scanner.start(
          { facingMode: "environment" },
          { fps: 15, qrbox: 280 },
          async (decodedText) => {
            if (procesando.current) return;
            procesando.current = true;

            const dni = decodedText.trim();
            await enviar(dni);
          }
        );
      } catch (err) {
        console.error(err);

        Swal.fire({
          icon: "error",
          title: "Error cámara",
          text: "No se pudo acceder",
        });
      }
    };

    iniciar();

    return () => {
      detenerScanner();
    };
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0, // 🔥 ocupa toda la pantalla
        background: "#000",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          height: 60,
          background: "#111",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 15px",
        }}
      >
        <span>Escanear QR</span>

        <button
          onClick={async () => {
            await detenerScanner();
            onClose?.();
          }}
          style={{
            background: "red",
            color: "#fff",
            border: "none",
            padding: "8px 12px",
            borderRadius: 6,
          }}
        >
          Cerrar
        </button>
      </div>

      {/* SCANNER FULL */}
      <div
        id="qr-reader"
        style={{
          flex: 1,
          width: "100%",
        }}
      />
    </div>
  );
};

export default BlanqueadorContraseaUsuariosQR;